"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var PollerManager_1 = __importDefault(require("./PollerManager"));
var hooks_1 = require("../hooks");
var usePoller = function (options) {
    var pollerName = options.pollerName, executableAction = options.executableAction, variables = options.variables, isPollingTurnedOff = options.isPollingTurnedOff, args = options.args, skipInitialRequest = options.skipInitialRequest;
    var pollerManager = options.pollerManager || PollerManager_1.default();
    var dispatch = react_redux_1.useDispatch();
    var pollerRef = react_1.useRef(pollerManager.get(pollerName));
    hooks_1.useMount(function () {
        if (!executableAction)
            return;
        if (pollerRef.current) {
            if (variables) {
                pollerRef.current.setVariables(variables);
            }
            return;
        }
        pollerRef.current = pollerManager.create({
            dispatch: dispatch,
            name: pollerName,
            actionCreator: executableAction,
            variables: variables,
            extraArgs: args,
        });
        if (!isPollingTurnedOff) {
            pollerRef.current.enable({ skipRequest: skipInitialRequest });
        }
        return function () {
            var _a, _b;
            (_a = pollerRef.current) === null || _a === void 0 ? void 0 : _a.disable();
            (_b = pollerRef.current) === null || _b === void 0 ? void 0 : _b.clearVariables();
        };
    });
    var memVariables = hooks_1.useDeepMemo(variables);
    var memArgs = hooks_1.useDeepMemo(args);
    react_1.useEffect(function () {
        var _a;
        if (!memVariables)
            return;
        (_a = pollerRef.current) === null || _a === void 0 ? void 0 : _a.setVariables(memVariables, memArgs);
    }, [memVariables, memArgs]);
    hooks_1.useDidUpdate(function () {
        var _a, _b;
        if (isPollingTurnedOff) {
            (_a = pollerRef.current) === null || _a === void 0 ? void 0 : _a.disable();
            return;
        }
        (_b = pollerRef.current) === null || _b === void 0 ? void 0 : _b.enable({ skipRequest: true });
        return function () {
            var _a;
            (_a = pollerRef.current) === null || _a === void 0 ? void 0 : _a.disable();
        };
    }, [isPollingTurnedOff]);
    var requestContent = react_1.useCallback(function () {
        var _a;
        (_a = pollerRef.current) === null || _a === void 0 ? void 0 : _a.requestContent();
    }, []);
    return { requestContent: requestContent };
};
exports.default = usePoller;
//# sourceMappingURL=usePoller.js.map